import API from '../../sunwiseAPI';
const ENTITY = 'aftersales-end-csv';

export const getReportCsv = (uuid) =>
    API.get(`/api/v1/${ENTITY}/${uuid}/sunpay`, { responseType: 'blob' });
